import storage from 'store2'

// Rename 'store2' to 'storage2' to make it less ambigious
export default storage
